import { nanoid } from '@reduxjs/toolkit';
import { loadMetaPixel, metaPageView, trackMetaEvent } from './meta-pixel';
import {
  googleAnnalyticsPageView,
  googleAnnalyticsTrackEvent,
  loadGoogleAnalytics,
} from './google-analytics';
import { getClient } from '../../lib/info';

export interface EventParams {
  action: string;
  category: string;
  label: string;
  value?: number;
  url?: string;
  isModifying?: boolean;
}

export const loadAnalytics = (
  googleAnalyticsId: string | undefined,
  metaPixelId: string | undefined,
): void => {
  loadMetaPixel(metaPixelId);
  loadGoogleAnalytics(googleAnalyticsId);
};

export const getSessionId = (): string => {
  let sessionId = localStorage.getItem('session_id');
  if (!sessionId) {
    sessionId = nanoid();
    localStorage.setItem('session_id', sessionId);
  }
  return sessionId;
};

export const pageView = (url: string, title: string) => {
  const { isModify } = getClient();
  googleAnnalyticsPageView(url, title, isModify);
  metaPageView(url, title, isModify);
};

export const trackEvent = (params: EventParams) => {
  const { isModify } = getClient();

  googleAnnalyticsTrackEvent({ ...params, isModifying: isModify });
  trackMetaEvent({ ...params, isModifying: isModify });
};
